import { makeStyles } from '@material-ui/core/styles';

export const useSideNavigationMenuStyles = makeStyles(() => ({
    wrapper: {
        zIndex: 102,
    },
}));
